import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbCardModule,
  NbButtonModule,
  NbCheckboxModule,
  NbInputModule,
  NbSelectModule,
  NbDatepickerModule,
  NbIconModule,
  NbTabsetModule,
  NbToggleModule,
  NbAccordionModule,
  NbTagModule,
  NbBadgeModule,
  NbButtonGroupModule,
  NbTooltipModule,
  NbProgressBarModule,
  NbPopoverModule,
  NbFormFieldModule,
  NbDialogModule,
} from '@nebular/theme';

@NgModule({
  imports: [
    CommonModule,
    NbCardModule,
    NbButtonModule,
    NbCheckboxModule,
    NbInputModule,
    NbSelectModule,
    NbDatepickerModule,
    NbIconModule,
    NbTabsetModule,
    NbToggleModule,
    NbAccordionModule,
    NbTagModule,
    NbBadgeModule,
    NbButtonGroupModule,
    NbTooltipModule,
    NbProgressBarModule,
    NbPopoverModule,
    NbFormFieldModule,
    NbDialogModule,
  ],
  exports: [
    NbCardModule,
    NbButtonModule,
    NbCheckboxModule,
    NbInputModule,
    NbSelectModule,
    NbDatepickerModule,
    NbIconModule,
    NbTabsetModule,
    NbToggleModule,
    NbAccordionModule,
    NbTagModule,
    NbBadgeModule,
    NbButtonGroupModule,
    NbTooltipModule,
    NbProgressBarModule,
    NbPopoverModule,
    NbFormFieldModule,
    NbDialogModule,
  ],
})
export class NebularModule {}
